export const reportConstants = {
  EVENT_REPORT: 0,
  CUSTOMER_REPORT: 1,
  SHUTTERB_REPORT: 2,
  REPORT_DATA: "REPORT_DATA",
  EVENT_REPORT_NAME: "EventReport",
  CUSTOMER_REPORT_NAME: "CustomerReport",
  SHUTTERB_REPORT_NAME: "ShutterBReport",
};
